export const replaceQueryParam = (url: URL, replacements: { name: string; value?: string }[]) => {
	const { searchParams } = url;
	replacements.forEach(({ name, value }) => {
		if (value) {
			if (searchParams.has(name)) {
				searchParams.set(name, value);
			} else {
				searchParams.append(name, value);
			}
		} else {
			searchParams.delete(name);
		}
	});
	return url.toString();
};
